import { useQueryClient } from "@tanstack/react-query";
import { useContext, useState } from "react";
import useGetOrg from "src/hooks/useGetOrganization";
import useLocales from "src/hooks/useLocales";
import Context from "src/pages/App/AppSettings/Customization/context";
import { useCreatAppCustomization } from "src/services/organizations/commands/customization";
import { AppThemeType, ColorThemeType } from "src/types/apps";
import SnackbarUtils from "src/utils/SnackbarUtils";

import { CustomizeFormValues } from "../hooks/customizeFormUtils";

export const useCreateCustomization = () => {
	const [isLoading, setisLoading] = useState(false);

	const { actions, state } = useContext(Context);

	const queryClient = useQueryClient();
	const { id } = useGetOrg();
	const { translate } = useLocales();
	const appId = queryClient.getQueryData<string>(["apps", "selected"]) ?? "";
	const appTheme = queryClient.getQueryData<AppThemeType>(["apps", "custom", appId]);

	const { mutate } = useCreatAppCustomization({ orgId: id, appId });

	const onSaveTheme = (values: CustomizeFormValues) => {
		setisLoading(true);
		const colors: ColorThemeType = {
			primary: values.primaryColor,
			primaryText: values.primaryTextColor,
			secondaryText: values.secondaryTextColor,
			buttonBackground: values.buttonBackgroundColor,
			buttonText: values.buttonTextColor,
			contentBackground: values.contentBackgroundColor,
			pageBackground: values.pageBackgroundColor,
			stroke: values.strokeColor,
			mainError: values.mainError,
			lightError: values.lightError,
			darkError: values.darkError
		};
		const button = {
			shape: values.buttonShape,
			textWeight: values.buttonTextWeight,
			width: values.buttonFullWidth
		};

		const data = new FormData();
		if (appTheme?.id) {
			data.append("id", appTheme?.id);
		}

		data.append("type", state.type);
		data.append("showExit", values.showExit ? "true" : "false");
		data.append("colors", new Blob([JSON.stringify(colors)], { type: "application/json" }));
		data.append("button", new Blob([JSON.stringify(button)], { type: "application/json" }));

		if (values.file) {
			data.append("logo", values.file);
		}

		mutate(data, {
			onSuccess: () => {
				setisLoading(false);
				SnackbarUtils.success(translate("customization.save_style_success"));
				actions.hideCustomDialog();
			},
			onError: () => {
				setisLoading(false);
				SnackbarUtils.error(translate("customization.save_style_error"));
			}
		});
	};
	return {
		isLoading,
		onSaveTheme
	};
};
